import { type Locale, siteNames } from '@seek/melways-sites';

import {
  type DevContext,
  type EmployerSiteName,
  type Environment,
  WindowConfigItemKey,
} from 'src/types/types';

export const createWindowConfig = ({
  site,
  environment,
  locale,
  isTrackingEnabled,
}: {
  site: EmployerSiteName; // Remove this when isNZ is removed
  environment: Environment;
  locale: Locale;
  isTrackingEnabled: boolean;
}) => ({
  [WindowConfigItemKey.SITE]: site,
  [WindowConfigItemKey.ENV]: environment,
  [WindowConfigItemKey.LOCALE]: locale,
  [WindowConfigItemKey.IS_TRACKING_ENABLED]: isTrackingEnabled,
});

type ConfigItemFallback = any;

const getConfigItem = (
  configItem: WindowConfigItemKey,
  fallback: ConfigItemFallback,
) => {
  if (typeof window !== 'undefined' && window.__config) {
    const configValue = window.__config[configItem];
    if (configValue === undefined) {
      return fallback;
    }
    return configValue;
  }
  return fallback;
};

export const getEnvironment = (): Environment =>
  getConfigItem(WindowConfigItemKey.ENV, 'development');

export const getSite = (): EmployerSiteName =>
  getConfigItem(WindowConfigItemKey.SITE, siteNames.employer.seek.au);

export const getLocale = (): Locale =>
  getConfigItem(WindowConfigItemKey.LOCALE, 'en-AU');

export const isLocalDev = (): boolean => getEnvironment() === 'development';

export const isStaging = (): boolean => getEnvironment() === 'staging';

export const isProd = (): boolean => getEnvironment() === 'production';

export const isNZ = (): boolean => getSite() === siteNames.employer.seek.nz;

export const getDevContext = (): DevContext | null =>
  getConfigItem(WindowConfigItemKey.DEV_CONTEXT, null);

export const isTrackingEnabled = (): boolean =>
  getConfigItem(WindowConfigItemKey.IS_TRACKING_ENABLED, false);
